import { Component, Input } from '@angular/core';

@Component({
    selector: 'apc-code-value-form',
    templateUrl: './code-value-form.component.html',
    styleUrls: ['./code-value-form.component.scss'],
    standalone: false
})
export class CodeValueFormComponent {
  @Input() public form: any;
  @Input() public section: string;
  @Input() public type: string;
}
